import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";
import {TreatmentJourneyDefinitionSummaryModel} from "./treatmentJourneyDefinitionSummary.model";
import {PermissionsConverter} from "../../../../../../../common/converter/permissions.converter";
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyDefinitionSummaryConverter extends HttpModelConverter<TreatmentJourneyDefinitionSummaryModel> {

    constructor(private permissionsConverter: PermissionsConverter) {
        super();
    }

    protected createInstance(): TreatmentJourneyDefinitionSummaryModel {
        return new TreatmentJourneyDefinitionSummaryModel();
    }

    protected enrichObject(result: TreatmentJourneyDefinitionSummaryModel, src: TreatmentJourneyDefinitionSummaryModel) {
        result.permissions = this.permissionsConverter.convert(src.permissions);
    }


}